import React from 'react';
import './index.scss';
export const DefaultItemHeight = 96;
const SlideItem = ({ icon, title, content, itemHeight }) => {
    return (React.createElement("div", { className: "slide-item-container", style: {
            height: itemHeight !== null && itemHeight !== void 0 ? itemHeight : DefaultItemHeight,
        } },
        React.createElement("div", { className: "slide-item-top" },
            icon,
            React.createElement("span", { className: "slide-item-title" },
                " ",
                title)),
        React.createElement("p", { className: "slide-item-bottom" },
            content,
            " ")));
};
export default SlideItem;
